import React, { FC } from 'react';
import Modal from '../Modal/modal';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';

interface IConfirmationModal {
  children: React.ReactNode;
  isOpen: boolean;
  title?: string;               // made optional — can use default
  message?: string;             // short description / warning
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  btnText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'danger' | 'warning'; // more flexibility
  size?: 'modal-xl' | 'modal-md' | 'modal-sm';
  icon?: React.ReactNode;       // e.g. warning icon
}

const ConfirmationModal: FC<IConfirmationModal> = ({
  children,
  isOpen,
  title = "Confirm Action",
  message,
  onClose,
  onConfirm,
  isLoading = false,
  btnText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "danger",
  size = "modal-md",            // changed default to md — sm often too narrow
  icon,
}) => {
  return (
    <Modal
      modalSize={size}
      title={title}
      isModalOpen={isOpen}
      closeModal={onClose}
      staticBackdrop={true}           // ← prevents closing on backdrop click
      noKeyboardClose={true}          // ← prevents ESC close (common for delete)
      renderFooter={() => (
        <div className="d-flex gap-3 justify-content-end mt-4 mb-2">
          <SecondaryButton
            onClick={onClose}
            title={cancelText}
            isLoading={isLoading}
          />
          <PrimaryButton
            onClick={onConfirm}
            title={btnText || ' Yes, Delete It!'}

            type='button'
            // variant={confirmVariant}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </div>
      )}
    >
      <div className="d-flex align-items-start gap-3">
        {icon && <div className="fs-1 text-warning">{icon}</div>}

        <div className="flex-grow-1">
          {message && (
            <p className="text-muted mb-3">{message}</p>
          )}
          {children}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;